import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

import { computed, onMounted, onUnmounted } from "vue";
import NavBar from "./components/navbar//Navbar.vue";
import { useGlobalStore } from "./stores/GlobalStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const globalStore = useGlobalStore();

onMounted(() => {
  globalStore.getState();
  globalStore.updateIsMobile();
  window.addEventListener("resize", globalStore.updateIsMobile);
  // console.log(document.getElementById("window")?.innerHTML);
  // globalStore.theme
});
onUnmounted(() => {
  window.removeEventListener("resize", globalStore.updateIsMobile);
});

const containerClass = computed(() => {
  const isDarkTheme = globalStore.theme === "dark"; // Determine the theme

  const gradientBg = globalStore.bgThemeClass;

  const textColor = isDarkTheme ? "text-light" : "text-black";

  return `${gradientBg} ${textColor}`;
});

// const containerClass = computed(() => {
//   return `bg-${globalStore.theme} text-${globalStore.theme === "dark" ? "light" : "black"}`;
// });

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["overflow-auto w-100 vh-100 d-flex flex-column", containerClass.value]),
    id: "window"
  }, [
    _createVNode(NavBar, {
      theme: _unref(globalStore).theme
    }, null, 8, ["theme"]),
    _createVNode(_component_RouterView),
    _cache[0] || (_cache[0] = _createElementVNode("div", {
      id: "innerModals",
      class: "bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900"
    }, null, -1))
  ], 2)), [
    [_directive_auto_animate, { duration: 200 }]
  ])
}
}

})